import React, { ComponentProps } from 'react';
import { HeartIcon } from '@/component-library';
import { LOT_THEME } from '../_Common/lot.common.styles';

export const Heart: React.FC<ComponentProps<typeof HeartIcon>> = ({
  ...props
}) => {
  const speed = '0.6s';
  return (
    <svg
      width={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={LOT_THEME.graysGray}
        stroke={LOT_THEME.graysRed}
        strokeWidth="0%"
        d="M19.9062226,5.01174686 C17.6483849,3.11332914 14.1601196,3.39847708 11.9999762,5.59768296 C9.83983269,3.39847708 6.35156738,3.10940001 4.09372975,5.01174686 C1.15626727,7.48438958 1.58595375,11.5156376 3.6796835,13.6523589 L10.5312449,20.6328186 C10.921869,21.0312628 11.4452824,21.253888 11.9999762,21.253888 C12.5585609,21.253888 13.0780833,21.0351538 13.4687074,20.6367096 L20.3202688,13.6562499 C22.4101076,11.5195667 22.8476142,7.48831871 19.9062226,5.01174686 Z M18.9843269,12.3359481 L12.1328036,19.3164079 C12.0390386,19.4101729 11.9609138,19.4101729 11.8671487,19.3164079 L5.01562544,12.3359481 C3.58984759,10.882819 3.30077052,8.13284842 5.30077338,6.4492358 C6.82031627,5.17192561 9.16406068,5.36330852 10.6327919,6.85939107 L11.9999762,8.25392663 L13.3671604,6.85939107 C14.8437117,5.35548841 17.1874562,5.17192561 18.6991789,6.44534482 C20.6952527,8.12891929 20.3983936,10.8945682 18.9843269,12.3359481 Z"
      >
        <animate
          begin="indefinite"
          attributeName="fill"
          values={`${LOT_THEME.graysGray};${LOT_THEME.graysRed};${LOT_THEME.graysGray}`}
          dur={speed}
          fill="freeze"
        />
        <animate
          begin="indefinite"
          attributeName="stroke-width"
          values={`0%;5%;0%`}
          dur={speed}
          fill="freeze"
        />
      </path>
    </svg>
  );
};
